import styled from 'styled-components';
import { colors } from '@/styles';

export const FullscreenExpando = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* height: 100%; */
  &.section {
    flex: 1;
    height: calc(100% - 100px);
    /* border: 3px double red; */
    transition: all 0.3s ease; /* For smooth animation */
  }

  &.full-screen {
    background: ${colors.secondary.lightGray1};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100; /* Ensure it's on top of other elements */
    /* border: 3px double magenta; */
  }
`;

export const FullscreenToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  background: transparent;
  border: none;
  border-radius: 5px;
  color: ${colors.secondary.mediumGray};
  transition: all 0.1s ease;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;
